import React, { useState } from 'react';
import './CommonStyles.css';
import './Products.css';
import './ProductsActions.css';
import './MobileResponsive.css';

const PaymentAccounts = () => {
  const [activeTab, setActiveTab] = useState('list_accounts');
  const [searchTerm, setSearchTerm] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [filterStatus, setFilterStatus] = useState('Active');
  const [openActionId, setOpenActionId] = useState(null);
  const [showExportMenu, setShowExportMenu] = useState(false);
  const [showAddAccountModal, setShowAddAccountModal] = useState(false);
  const [accountForm, setAccountForm] = useState({
    name: '',
    accountNumber: '',
    accountType: '',
    openingBalance: '0',
    note: ''
  });
  const [accountDetails, setAccountDetails] = useState([{ label: '', value: '' }]);

  const handleFormChange = (field, value) => {
    setAccountForm(prev => ({ ...prev, [field]: value }));
  };

  const addDetailRow = () => {
    setAccountDetails(prev => [...prev, { label: '', value: '' }]);
  };

  const removeDetailRow = (index) => {
    setAccountDetails(prev => prev.filter((_, i) => i !== index));
  };

  const handleDetailChange = (index, field, value) => {
    setAccountDetails(prev => prev.map((row, i) => i === index ? { ...row, [field]: value } : row));
  };

  // Add Account Type Modal state
  const [showAddAccountTypeModal, setShowAddAccountTypeModal] = useState(false);
  const [accountTypeForm, setAccountTypeForm] = useState({
    name: '',
    parentAccountType: ''
  });

  const handleAccountTypeFormChange = (field, value) => {
    setAccountTypeForm(prev => ({ ...prev, [field]: value }));
  };

  const handleAddAccountTypeSubmit = () => {
    console.log('Account Type Form:', accountTypeForm);
    setShowAddAccountTypeModal(false);
    setAccountTypeForm({ name: '', parentAccountType: '' });
  };

  const handleAddAccountSubmit = () => {
    // TODO: API call to save account
    console.log('Account Form:', accountForm, 'Details:', accountDetails);
    setShowAddAccountModal(false);
    setAccountForm({ name: '', accountNumber: '', accountType: '', openingBalance: '0', note: '' });
    setAccountDetails([{ label: '', value: '' }]);
  };

  // Sample data for List Accounts
  const accounts = [
    { id: 1, name: 'Axis bank', accountType: 'Bank', accountSubType: '', accountNumber: '25689642233', balance: 126051.00, note: '', addedBy: 'Mr Ajay Gogia' },
    { id: 2, name: 'Cash on Hand', accountType: 'Cash on Hand', accountSubType: '', accountNumber: '123', balance: -39852.42, note: '', addedBy: 'Mr Ajay Gogia' },
    { id: 3, name: 'CASH ON HAND', accountType: 'Cash on Hand', accountSubType: '', accountNumber: 'CASH ON HAND', balance: 137350.00, note: '', addedBy: 'Mr Ajay Gogia' }
  ];

  // Sample data for Account Types
  const accountTypes = [
    { id: 1, name: 'Bank', parentType: 'Asset' },
    { id: 2, name: 'Cash on Hand', parentType: 'Asset' },
    { id: 3, name: 'Equity', parentType: 'Equity' },
    { id: 4, name: 'Revenue', parentType: 'Income' }
  ];

  const toggleActionMenu = (id) => {
    setOpenActionId(openActionId === id ? null : id);
  };

  const getAddButtonLabel = () => {
    switch (activeTab) {
      case 'list_accounts': return 'Add Account';
      case 'account_types': return 'Add Account Type';
      default: return null;
    }
  };

  return (
    <div className="products-container">

      {/* Tabs Row with Search + Filters */}
      <div className="main-card">
        <div className="product-tabs" style={{ marginBottom: '0', borderBottom: '2px solid var(--etpos-border)', flexWrap: 'nowrap', alignItems: 'center', overflow: 'visible', gap: '0.5rem' }}>
          <div
            className={`product-tab ${activeTab === 'list_accounts' ? 'active' : ''}`}
            onClick={() => setActiveTab('list_accounts')}
            style={{ padding: '0.75rem 0.4rem', whiteSpace: 'nowrap' }}
          >
            <i className="fa fa-list"></i> List Accounts
          </div>
          <div
            className={`product-tab ${activeTab === 'account_types' ? 'active' : ''}`}
            onClick={() => setActiveTab('account_types')}
            style={{ padding: '0.75rem 0.4rem', whiteSpace: 'nowrap' }}
          >
            Account Types
          </div>
          <div
            className={`product-tab ${activeTab === 'balance_sheet' ? 'active' : ''}`}
            onClick={() => setActiveTab('balance_sheet')}
            style={{ padding: '0.75rem 0.4rem', whiteSpace: 'nowrap' }}
          >
            Balance Sheet
          </div>
          <div
            className={`product-tab ${activeTab === 'trial_balance' ? 'active' : ''}`}
            onClick={() => setActiveTab('trial_balance')}
            style={{ padding: '0.75rem 0.4rem', whiteSpace: 'nowrap' }}
          >
            Trial Balance
          </div>
          <div
            className={`product-tab ${activeTab === 'cash_flow' ? 'active' : ''}`}
            onClick={() => setActiveTab('cash_flow')}
            style={{ padding: '0.75rem 0.4rem', whiteSpace: 'nowrap' }}
          >
            Cash Flow
          </div>
          <div
            className={`product-tab ${activeTab === 'payment_report' ? 'active' : ''}`}
            onClick={() => setActiveTab('payment_report')}
            style={{ padding: '0.75rem 0.4rem', whiteSpace: 'nowrap' }}
          >
            Payment Report
          </div>

        </div>

        {/* Filter Modal Popup */}
        {showFilters && (
          <div className="modal-overlay" onClick={() => setShowFilters(false)}>
            <div className="modal-container filter-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px', width: '95%' }}>
              <div className="modal-header">
                <h2>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '0.5rem', verticalAlign: 'middle' }}>
                    <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
                  </svg>
                  Filters
                </h2>
                <button className="modal-close-btn" onClick={() => setShowFilters(false)}>✕</button>
              </div>
              <div className="modal-content" style={{ padding: '1.5rem' }}>
                <div className="filter-row">
                  <div className="filter-group">
                    <label>Account Status:</label>
                    <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                      <option value="All">All</option>
                    </select>
                  </div>
                  <div className="filter-group">
                    <label>Account Type:</label>
                    <select>
                      <option value="all">All Types</option>
                      <option value="Bank">Bank</option>
                      <option value="Cash on Hand">Cash on Hand</option>
                      <option value="Equity">Equity</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="modal-btn close-btn" onClick={() => setShowFilters(false)}>Close</button>
              </div>
            </div>
          </div>
        )}

        {/* Table Controls Row */}
        <div className="table-controls">
          <div className="table-controls-left">
            <div className="entries-dropdown">
              <span>Show</span>
              <select defaultValue={25}>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <span>entries</span>
            </div>
          </div>

          <div className="table-controls-right">
            <div className="tabs-search-wrapper">
              <input
                className="tabs-search-input"
                placeholder="Search..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
              />
              <button className="filter-toggle-btn" onClick={() => setShowFilters(true)} title="Open Filters">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
                </svg>
                Filters
              </button>
            </div>
            {/* Export Dropdown */}
            <div className="export-dropdown-container">
              <button
                className="export-btn"
                onClick={() => setShowExportMenu(!showExportMenu)}
              >
                <i className="fa fa-download"></i> Export <span style={{ fontSize: '0.6rem' }}>▼</span>
              </button>
              {showExportMenu && (
                <div className="export-dropdown-menu">
                  <button><i className="fa fa-file-csv"></i> Export CSV</button>
                  <button><i className="fa fa-file-excel"></i> Export Excel</button>
                  <button><i className="fa fa-file-pdf"></i> Export PDF</button>
                  <button><i className="fa fa-print"></i> Print</button>
                </div>
              )}
            </div>

            {/* Add Button */}
            {getAddButtonLabel() && (
              <button className="control-btn-primary" onClick={() => {
                if (activeTab === 'list_accounts') setShowAddAccountModal(true);
                if (activeTab === 'account_types') setShowAddAccountTypeModal(true);
              }}>
                <span className="plus-icon">+</span> {getAddButtonLabel()}
              </button>
            )}
          </div>
        </div>

        {/* List Accounts Table */}
        {activeTab === 'list_accounts' && (
          <div className="products-table-container">
            <table className="products-table">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Name</th>
                  <th>Account Type</th>
                  <th>Account Sub Type</th>
                  <th>Account Number</th>
                  <th>Note</th>
                  <th>Balance</th>
                  <th>Account details</th>
                  <th>Added By</th>
                </tr>
              </thead>
              <tbody>
                {accounts
                  .filter(a =>
                    a.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    a.accountNumber.toLowerCase().includes(searchTerm.toLowerCase())
                  )
                  .map((account) => (
                    <tr key={account.id}>
                      <td className="actions-cell">
                        <div className="action-dropdown-container">
                          <button
                            className="action-btn-trigger"
                            onClick={() => toggleActionMenu(account.id)}
                          >
                            Actions <span className="arrow-down">▼</span>
                          </button>
                          {openActionId === account.id && (
                            <div className="action-dropdown-menu">
                              <button>Edit</button>
                              <button>Account Book</button>
                              <button>Fund Transfer</button>
                              <button>Deposit</button>
                              <button>Close</button>
                            </div>
                          )}
                        </div>
                      </td>
                      <td>{account.name}</td>
                      <td>{account.accountType}</td>
                      <td>{account.accountSubType || '-'}</td>
                      <td>{account.accountNumber}</td>
                      <td>{account.note || '-'}</td>
                      <td style={{ color: account.balance >= 0 ? '#10b981' : '#ef4444', fontWeight: '600' }}>
                        $ {account.balance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                      <td>-</td>
                      <td>{account.addedBy}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Account Types Table */}
        {activeTab === 'account_types' && (
          <div className="products-table-container">
            <table className="products-table">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Account Type</th>
                  <th>Parent Account Type</th>
                </tr>
              </thead>
              <tbody>
                {accountTypes
                  .filter(t => t.name.toLowerCase().includes(searchTerm.toLowerCase()))
                  .map((type) => (
                    <tr key={type.id}>
                      <td className="actions-cell">
                        <div className="action-dropdown-container">
                          <button
                            className="action-btn-trigger"
                            onClick={() => toggleActionMenu(`type-${type.id}`)}
                          >
                            Actions <span className="arrow-down">▼</span>
                          </button>
                          {openActionId === `type-${type.id}` && (
                            <div className="action-dropdown-menu">
                              <button>Edit</button>
                              <button>Delete</button>
                            </div>
                          )}
                        </div>
                      </td>
                      <td>{type.name}</td>
                      <td>{type.parentType}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Placeholder for report tabs */}
        {!['list_accounts', 'account_types'].includes(activeTab) && (
          <div className="products-table-container" style={{ padding: '3rem', textAlign: 'center' }}>
            <h3>{activeTab.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</h3>
            <p style={{ color: 'var(--etpos-text-muted)' }}>Content for {activeTab.replace(/_/g, ' ')} will be displayed here.</p>
          </div>
        )}
      </div>

      {/* Add Account Modal */}
      {showAddAccountModal && (
        <div className="modal-overlay" onClick={() => setShowAddAccountModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '550px' }}>
            <div className="modal-header" style={{ padding: '1rem 1.5rem', borderBottom: '1px solid var(--etpos-border)' }}>
              <h3 style={{ margin: 0 }}>Add Account</h3>
              <button className="close-btn" onClick={() => setShowAddAccountModal(false)}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" /></svg>
              </button>
            </div>
            <div className="modal-body" style={{ padding: '1.5rem' }}>
              {/* Name */}
              <div className="form-group" style={{ marginBottom: '1rem' }}>
                <label>Name: <span style={{ color: '#ef4444' }}>*</span></label>
                <input
                  type="text"
                  placeholder="Name"
                  value={accountForm.name}
                  onChange={(e) => handleFormChange('name', e.target.value)}
                />
              </div>

              {/* Account Number */}
              <div className="form-group" style={{ marginBottom: '1rem' }}>
                <label>Account Number: <span style={{ color: '#ef4444' }}>*</span></label>
                <input
                  type="text"
                  placeholder="Account Number"
                  value={accountForm.accountNumber}
                  onChange={(e) => handleFormChange('accountNumber', e.target.value)}
                />
              </div>

              {/* Account Type */}
              <div className="form-group" style={{ marginBottom: '1rem' }}>
                <label>Account Type:</label>
                <select
                  value={accountForm.accountType}
                  onChange={(e) => handleFormChange('accountType', e.target.value)}
                >
                  <option value="">Select Account Type</option>
                  <option value="Bank">Bank</option>
                  <option value="Cash on Hand">Cash on Hand</option>
                  <option value="Equity">Equity</option>
                  <option value="Revenue">Revenue</option>
                </select>
              </div>

              {/* Opening Balance */}
              <div className="form-group" style={{ marginBottom: '1rem' }}>
                <label>Opening Balance:</label>
                <input
                  type="number"
                  placeholder="0"
                  value={accountForm.openingBalance}
                  onChange={(e) => handleFormChange('openingBalance', e.target.value)}
                />
              </div>

              {/* Account Details - Label/Value rows */}
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ fontWeight: '500', fontSize: '0.875rem', color: 'var(--etpos-text)', display: 'block', marginBottom: '0.5rem' }}>Account details:</label>
                <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid var(--etpos-border)', borderRadius: '0.5rem' }}>
                  <thead>
                    <tr>
                      <th style={{ padding: '0.5rem 0.75rem', background: 'var(--etpos-bg)', fontSize: '0.8rem', fontWeight: '600', textAlign: 'left', borderBottom: '1px solid var(--etpos-border)' }}>Label</th>
                      <th style={{ padding: '0.5rem 0.75rem', background: 'var(--etpos-bg)', fontSize: '0.8rem', fontWeight: '600', textAlign: 'left', borderBottom: '1px solid var(--etpos-border)' }}>Value</th>
                      <th style={{ padding: '0.5rem', background: 'var(--etpos-bg)', borderBottom: '1px solid var(--etpos-border)', width: '40px' }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {accountDetails.map((row, index) => (
                      <tr key={index}>
                        <td style={{ padding: '0.4rem 0.5rem' }}>
                          <input
                            type="text"
                            placeholder="Label"
                            value={row.label}
                            onChange={(e) => handleDetailChange(index, 'label', e.target.value)}
                            style={{ width: '100%', padding: '0.4rem 0.6rem', border: '1px solid var(--etpos-border)', borderRadius: '4px', fontSize: '0.85rem' }}
                          />
                        </td>
                        <td style={{ padding: '0.4rem 0.5rem' }}>
                          <input
                            type="text"
                            placeholder="Value"
                            value={row.value}
                            onChange={(e) => handleDetailChange(index, 'value', e.target.value)}
                            style={{ width: '100%', padding: '0.4rem 0.6rem', border: '1px solid var(--etpos-border)', borderRadius: '4px', fontSize: '0.85rem' }}
                          />
                        </td>
                        <td style={{ padding: '0.4rem 0.25rem', textAlign: 'center' }}>
                          {accountDetails.length > 1 && (
                            <button
                              onClick={() => removeDetailRow(index)}
                              style={{ background: 'rgba(239,68,68,0.1)', color: '#ef4444', border: 'none', borderRadius: '4px', width: '28px', height: '28px', cursor: 'pointer', fontSize: '1rem', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                            >
                              ×
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <button
                  onClick={addDetailRow}
                  style={{ marginTop: '0.5rem', padding: '0.35rem 0.75rem', background: 'var(--etpos-primary)', color: 'white', border: 'none', borderRadius: '4px', fontSize: '0.8rem', cursor: 'pointer' }}
                >
                  + Add Row
                </button>
              </div>

              {/* Note */}
              <div className="form-group" style={{ marginBottom: '0' }}>
                <label>Note:</label>
                <textarea
                  placeholder="Note"
                  value={accountForm.note}
                  onChange={(e) => handleFormChange('note', e.target.value)}
                  rows={3}
                  style={{ padding: '0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '0.5rem', fontSize: '0.95rem', resize: 'vertical', width: '100%', fontFamily: 'inherit' }}
                />
              </div>
            </div>
            <div className="modal-footer" style={{ justifyContent: 'center' }}>
              <button className="cancel-btn" onClick={() => setShowAddAccountModal(false)}>Cancel</button>
              <button className="submit-btn" onClick={handleAddAccountSubmit}>Save</button>
            </div>
          </div>
        </div>
      )}

      {/* Add Account Type Modal */}
      {showAddAccountTypeModal && (
        <div className="modal-overlay" onClick={() => setShowAddAccountTypeModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '450px' }}>
            <div className="modal-header" style={{ padding: '1rem 1.5rem', borderBottom: '1px solid var(--etpos-border)' }}>
              <h3 style={{ margin: 0 }}>Add Account Type</h3>
              <button className="close-btn" onClick={() => setShowAddAccountTypeModal(false)}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" /></svg>
              </button>
            </div>
            <div className="modal-body" style={{ padding: '1.5rem' }}>
              {/* Name */}
              <div className="form-group" style={{ marginBottom: '1rem' }}>
                <label>Name: <span style={{ color: '#ef4444' }}>*</span></label>
                <input
                  type="text"
                  placeholder="Name"
                  value={accountTypeForm.name}
                  onChange={(e) => handleAccountTypeFormChange('name', e.target.value)}
                />
              </div>

              {/* Parent Account Type */}
              <div className="form-group" style={{ marginBottom: '0' }}>
                <label>Parent account type:</label>
                <select
                  value={accountTypeForm.parentAccountType}
                  onChange={(e) => handleAccountTypeFormChange('parentAccountType', e.target.value)}
                >
                  <option value="">Please Select</option>
                  <option value="NSF Return">NSF Return</option>
                  <option value="Bank">Bank</option>
                  <option value="Cash on Hand">Cash on Hand</option>

                </select>
              </div>
            </div>
            <div className="modal-footer" style={{ justifyContent: 'center' }}>
              <button className="cancel-btn" onClick={() => setShowAddAccountTypeModal(false)}>Cancel</button>
              <button className="submit-btn" onClick={handleAddAccountTypeSubmit}>Save</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default PaymentAccounts;
